// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_Column } from '../styles';


const YAColumn = (props) => {    
    return (
    	<SC_Column {...props} className={[props.size, !props.autoWidth ? 'col-12' : null]}>
            {props.children}
        </SC_Column>
    )
    
}
export default YAColumn;